export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8950.c26384e9.jpg";